import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";
import { GET_SITE_VISIT_HISTORY } from "../../../queries/archiveQrys/InventoryReportQueries";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const SiteVisitHistoryTable = ({ systemId }) => {
  const columns = [
    {
      Header: "Visit Date",
      accessor: (d) => {
        return d.visitDate ? convertTimeStampToDate(d.visitDate) : "";
      }
    },
    {
      Header: "Reason Type",
      accessor: "reasonType"
    },
    {
      Header: "Notified Date",
      accessor: (d) => {
        return d.notifiedDate ? convertTimeStampToDate(d.notifiedDate) : "";
      }
    },
    {
      Header: "Inspector Name",
      accessor: "inspectorName"
    },
    {
      Header: "Next Inspection Date",
      accessor: (d) => {
        return d.nextInspectionDate ? convertTimeStampToDate(d.nextInspectionDate) : "";
      }
    }
  ];

  const { loading, error, data } = useQuery(GET_SITE_VISIT_HISTORY, { variables: { systemId } });
  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;

  return (
    <>
      {data.getSiteVisitHistoryBySystemId.length > 0 ? (
        <DtsReactTable data={data.getSiteVisitHistoryBySystemId} columns={columns} headerColor='ddw' cypressid="SiteVisitHistoryTable"/>
      ) : (
        <span>
          <em>No data for site visit history was found in the database.</em>
        </span>
      )}
    </>
  );
};

export default SiteVisitHistoryTable;
